import { useAtom } from '@reatom/npm-react'
import * as DateF from 'date-fns'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { DATE_FORMAT } from '@root/shared'
import { useTranslation } from '@root/shared/localization'

import { premiumFontCss } from '../../constants'
import { PremiumListItem } from '../common/premium-list-item'

import { ExpiredPremiumListItemBuy } from './expired-premium-list-item-buy'

import type { CurrencyModel } from '@root/entities/currency'
import type { CurrencyWithPremium } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium/atoms'

type Props = {
  currency: CurrencyModel
  premium: PremiumMetaModel
  onBuyAgain: (currency: CurrencyWithPremium.CurrencyWithPremium) => void
}

export const ExpiredPremiumListItem: React.FC<Props> = ({
  currency,
  premium,
  onBuyAgain,
}) => {
  const { t } = useTranslation()
  const [expiresAt] = useAtom(premium.expiresAt)

  const handleBuyAgain = () =>
    onBuyAgain({
      currency,
      premium,
    })

  return (
    <PremiumListItem
      currency={currency}
      premiumMeta={premium}
      premiumInfo={
        <DateEnded>
          <span>{t('common.d-premium')}</span>
          <Trans
            i18nKey="premium.purchased.date-ended"
            components={[<span key={0} />]}
            values={{
              date: DateF.format(expiresAt, DATE_FORMAT.dd_MM_yy),
            }}
          />
        </DateEnded>
      }
      actions={<ExpiredPremiumListItemBuy onBuyAgain={handleBuyAgain} />}
    />
  )
}

const DateEnded = styled.span`
  color: var(--text-9);
  text-align: center;

  font-size: 10px;
  font-weight: 600;
  line-height: 12px;

  font-style: normal;
  justify-self: center;

  display: grid;
  grid-auto-flow: column;
  gap: 4px;

  span {
    ${premiumFontCss}
  }
`
